export default {
  successTenantTitle: 'Добрый день, {{name}} из {{companyName}}!',
  successUserTitle: 'Добрый день, {{name}}!',
  successText: 'Ваш аккаунт в edna Pulse создан!',
  linkRequested: 'Запрос новой ссылки для регистрации отправлен успешно',
  setPassword:
    'Вам необходимо придумать пароль, который в дальнейшем будет использоваться для входа в Личный кабинет.',
  yourLogin: 'Ваш логин',
  createPassword: 'Задайте пароль',
  repeatPassword: 'Повторите пароль',
  signIn: 'Войти в систему',
  acceptTerms:
    'Нажимая кнопку, вы согласны с условиями <0>Общих положений о предоставлении прав на использование программного обеспечения «edna»</0>',
  linkExpiredTitle: 'Ссылка больше недействительна',
  linkExpiredText: 'К сожалению, 24 часа действия ссылки истекли',
  requestLinkTitle: 'Запросите новую ссылку для регистрации и наш менеджер пришлет вам ее на почту',
  requestLink: 'Запросить повторно',
  linkAlreadyRequested: 'Вы уже запросили новую ссылку',
  wait: 'Надо немного подождать',
  requestLinkText:
    'Наш менеджер создаст вам для входа в систему новую ссылку и обязательно об этом сообщит',
  userLinkCancelledTitle: 'Ссылка отменена',
  userLinkCancelledSubtitle: 'По этой ссылке больше невозможно выполнить регистрацию.',
  userLinkCancelledDescription: 'Если вам необходим доступ в edna Pulse — запросите новую ссылку.',
  userLinkAcceptedTitle: 'Эта ссылка уже использована.',
  userLinkAcceptedSubtitle: 'Если у вас ещё нет доступа в edna Pulse, запросите новую ссылку.',
  selfRegistered: {
    successText: 'Придумайте пароль.',
    acceptTerms: 'Регистрируясь, вы соглашаетесь с условиями \n<0>Пользовательского соглашения</0>',
    linkAlreadyRequestedTitle: 'Ссылка отправлена на ваш email',
    linkAlreadyRequestedText: 'Ссылка для завершения регистрации уже отправлена на ваш email.',
    linkExpiredTitle: 'Ссылка для подтверждения устарела',
    linkExpiredSubtitle: 'Запросите новую — она придёт на ваш email',
    requestLink: 'Отправить повторно',
  },
  unknownError: {
    title: 'Что-то пошло не так',
    text:
      'При регистрации произошла непредвиденная ошибка.\n\n' +
      'Пожалуйста, попробуйте еще раз позже.',
  },
};
